<template>
  <div>
    <!--卡片布局-->
    <el-card shadow="always">
      <!--操作栏-->
      <div class="search-items">
        <div>
          <el-input size="small" v-model="queryInfo.queryStr" placeholder="请输入课程或项目名进行查询" clearable @clear="loadData()">
            <el-button size="small" slot="append" icon="el-icon-search" @click="loadData()"></el-button>
          </el-input>
        </div>
        <div>
          <el-button size="small" type="primary" @click="handleAdd()">发布</el-button>
          <el-button size="small" type="danger" @click="handleDeleteMulti()">删除所选</el-button>
        </div>
      </div>
      <!--表格-->
      <el-table :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50">
        </el-table-column>
        <!-- <el-table-column prop="cno" width="120" label="课程编号">
        </el-table-column> -->
        <el-table-column prop="cname" width="180" label="课程名称">
        </el-table-column>        
        <el-table-column prop="pname" width="240" label="项目名称">
        </el-table-column>
        <el-table-column prop="tnames" width="120" label="项目负责人">
        </el-table-column>         
        <el-table-column  width="140" label="截止时间">
           <template slot-scope="scope">{{timeFormate(scope.row.deadline)}}</template>
        </el-table-column>       
        <el-table-column  label="相关学生">                    
          <template slot-scope="scope">
           <div v-html='reselName(scope.row)'>  </div> 
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="handleUpdate(scope.row)"></el-button>
            <el-button type="danger" icon="el-icon-delete" @click="handleDeleteOne(scope.row.id)" size="mini"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.currentPage" :page-sizes="[1,5,10,100,1000]" :page-size="queryInfo.pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { selectProjectTaskList, deleteProjectTask } from '@/api/projectTask'
import CommonUtil from "@utils/common-util"
import { PICTURES_PROJECT,TASK_PUBLISH_LIST } from "@utils/constant"
export default {
  inject: ['reload'],
  name: "publishIndex",
  data() {
    return {
      formLabelWidth: '120px',
      selectNos: [],
      tableData: [],       //分页查询所有数据
      queryInfo: {
        queryStr: '',
        currentPage: 1,
        pageSize: 100
      },
      total: 0,
      file: null,
      allTableData: [],     //表格所有数据
      multipleSelection: [],       
    }
  },
  computed: {
    //时间
    timeFormate() {
      return function (time) {  
        return moment(time).format('yyyy-MM-DD HH:mm')
      }
    },
    reselName(){
      return function (row) {
        let relationSnameArr = row.relationSnames ? _.split(row.relationSnames, ',') : []
        let selectSnameArr = row.selectSnames ? _.split(row.selectSnames, ',') : []
        let hTemp = ''
        relationSnameArr.forEach((item) => {
          if(_.includes(selectSnameArr, item)){
            hTemp+='<font color="#409EFF">'+item+',</font>'
          }else{
            hTemp+='<font color="#60d58f">'+item+',</font>'
          }
        })
        return hTemp
      }
    }    
  },    
  created() {
    this.loadData();//分页条件获取所有学生信息
  },
  methods: {
    //添加对象
    handleAdd() {
      this.$router.push('/task/taskPublishAdd');
    },
    //编辑对象 
    handleUpdate(row) {
      this.$router.push({path:'/task/taskPublishUpdate',query:{id:row.id}});
    },
    //删除多个
    handleDeleteMulti() {
      let ids = []
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        ids = _.map(this.multipleSelection, 'id')
        // formData.append('ids', ids);
      }
      CommonUtil.deleteMultiple(ids,deleteProjectTask, this.loadData)
    },
    //删除
    handleDeleteOne(id) {
      // let params = { cno: cno }
      CommonUtil.deleteOne([id], deleteProjectTask, this.loadData)
    },

    handleSelectionChange(val) {
      //监听多选框值动态变化的事件
      this.multipleSelection = val;
    },
    //加载列表数据
    loadData() {
      //分页条件获取所有学生信息     
      let params = {
        queryStr: this.queryInfo.queryStr,
        currentPage: this.queryInfo.currentPage,
        pageSize: this.queryInfo.pageSize
      }
      selectProjectTaskList(params).then(response => {
        let rowDatas = response.data.data.entries;
        this.tableData = rowDatas
        this.total = response.data.data.total//response.data.data.total;
      });
    },
    changeFile(file) {
      //改变文件触发事件
      this.file = file;
    },
    beforeRemove(file) {
      //移除文件触发事件
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSizeChange(val) {
      //监听pageSize
      this.queryInfo.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      //监听currentPage
      this.queryInfo.currentPage = val;
      this.loadData();
    },
    getAllProject() {
      //用于excel的导出
      this.common.getAllData(this, this.apiUrl.selectAllProjects);
    }
  }
}
</script>

